<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        印章申请
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">印章审批流程</h4>
                    <p> 1. 适用范围</p>
                    <span class="spanClass labourParticulars-title-content-active" id="textTitleContent">对外提供的说明、公示等文件。</span>
                    <p>2. 申请流程</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【OA系统】。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第二步：点击【工作流】-【新建工作】-【标准化流程】-【总裁/总经理/校长办公室】-【标准|印章审批流程】-【新建并办理】，新建表单。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第三步：根据页面提示及要求填写相关信息。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">印章审批流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第四步：点击【+添加附件】上传合同文本，确认无误后，点击【提交】，及时关注合同审批情况，待完成全部审批后，携带纸质版文件前往校办高帆（gaofan14）处施印。</p>
                    <img src="../../assets/14.png" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'df'){
                this.$router.push({name:"IssueManpower3"})
            }else {
                this.$router.push({name:"AdministrativeHome"})
            }
        },
        fn() {

        },
        getOnPage() {
            this.$router.push({name: 'Search', params:{code:"1115"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative7.vue